import { Component, OnInit } from '@angular/core';
// import { AuthService } from '../../../core/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
// import { EntityManagerProvider } from 'src/app/core/core.module';
import { confirm, alert } from 'devextreme/ui/dialog';
import { first } from 'rxjs/operators';
import { AppInformationService, AuthenticationService } from 'src/app/core/core.module';
declare var jQuery: any;

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {
    model = { userName: '', password: '' };
    church: string;
    returnUrl: any;

    constructor(private auth: AuthenticationService, private router: Router, private route: ActivatedRoute, private appInfo: AppInformationService) {
        // redirect to home if already logged in
        if (this.auth.userValue) this.router.navigate(['/']);
    }

    ngOnInit() {
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    async login() {
        await this.appInfo.pleaseWaitShow();
        this.auth
            .login(this.model.userName, this.model.password)
            .pipe(first())
            .subscribe({
                next: async () => {
                    this.appInfo.pleaseWaitHide();
                    this.router.navigate([this.returnUrl]);
                },
                error: error => {
                    this.appInfo.pleaseWaitHide();
                    alert('Error logging into server: ' + error, 'Login Error');
                }
            });
    }
}
